import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-password-input", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-password-input></ux-password-input>`);
        const el = await page.find("ux-password-input");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-password-input error label="test"></ux-password-input>`);
        const el = await page.find("ux-password-input");
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot with some props", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-password-input label="Label"
                                     type="password"
                                     id="input" name="input" placeholder="Placeholder"></ux-password-input>`
        );
        const el = await page.find("ux-password-input");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-password-input label="Label" type="password" id="input" name="input" placeholder="Placeholder">
                  </ux-password-input>`
        );
    });

    it("should show tooltip", async () => {
        const page = await newE2EPage();
        await page.setContent(passwordTemplate());
        await page.waitForChanges();
        const uxPasswordInput = await page.find(".ux-password-input");
        const inputElement = await uxPasswordInput.find(".ux-input");
        const tooltipElement = await uxPasswordInput.find(".ux-tooltip__tip");
        await inputElement.click();
        await page.waitForChanges();
        expect(tooltipElement).toHaveClass("ux-tooltip__tip--active");
    });
});

export const passwordTemplate = () => {
    return `
    <ux-password-input value="De3!dede"
     required=""
     id="password"
     name="password"
     placeholder="Placeholder"
     label="Password"
     data-validation-required--msg="Please check all acceptance criteria"
     tooltip-headline="Passwortrichtlinien:"
     check-length-text="8 Zeichen"
     check-special-chars-text="1 Sonderzeichen"
     check-uppercase-text="1 Großbuchstabe"
     check-number-text="1 Zahl">
</ux-password-input>

    `;
};
